import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Section from '../Section'
import ReadMore from '../ReadMore'

const propTypes = {
  listing: PropTypes.object.isRequired,
  className: PropTypes.string,
}

const defaultProps = {
  className: '',
}

const Description = ({ listing, className }) => (
  <Section className={className}>
    <Section.Heading>
      <FormattedMessage
        id='HomeSearch.listingDetails.description'
        defaultMessage='Description'
      />
    </Section.Heading>
    <Section.Body>
      <ReadMore text={listing.description} truncateCount={500} />
    </Section.Body>
  </Section>
)

Description.propTypes = propTypes
Description.defaultProps = defaultProps

export default Description
